import { Heading } from "@chakra-ui/react";

// Nagłówek sekcji z cienką linią pod spodem — wspólny dla wszystkich list i bloków treści
const SectionTitle = ({ children, color = "ink.900", borderColor = "surface.border", ...rest }) => (
    <Heading as="h2" fontWeight={700} fontSize={{ base: '24px', md: '30px' }} letterSpacing="-0.5px" color={color}
             pb={{ base: '14px', md: '18px' }} mb={{ base: '20px', md: '28px' }} borderBottom="1px solid" borderColor={borderColor} w="100%"
             {...rest}>
        {children}
    </Heading>
);

export default SectionTitle;
